import { createDefault } from "../../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "新規登録", enum: "NEW" },
  { value: 2, text: "補填品有無回答済み", enum: "ANSWERED" },
  { value: 3, text: "出荷待ち", enum: "SHIPPING_WAIT" },
  { value: 4, text: "出荷済み", enum: "SHIPED" },
  { value: 5, text: "キャンセル", enum: "CANCELED" },
]);
